var MetadataModules;
(function (MetadataModules) {
    MetadataModules["CALIBRATION"] = "calibrationModule";
    MetadataModules["CINE"] = "cineModule";
    MetadataModules["GENERAL_IMAGE"] = "generalImageModule";
    MetadataModules["GENERAL_SERIES"] = "generalSeriesModule";
    MetadataModules["GENERAL_STUDY"] = "generalStudyModule";
    MetadataModules["IMAGE_PIXEL"] = "imagePixelModule";
    MetadataModules["IMAGE_PLANE"] = "imagePlaneModule";
    MetadataModules["IMAGE_URL"] = "imageUrlModule";
    MetadataModules["MODALITY_LUT"] = "modalityLutModule";
    MetadataModules["MULTIFRAME"] = "multiframeModule";
    MetadataModules["NM_MULTIFRAME_GEOMETRY"] = "nmMultiframeGeometryModule";
    MetadataModules["OVERLAY_PLANE"] = "overlayPlaneModule";
    MetadataModules["PATIENT"] = "patientModule";
    MetadataModules["PATIENT_STUDY"] = "patientStudyModule";
    MetadataModules["PET_IMAGE"] = "petImageModule";
    MetadataModules["PET_ISOTOPE"] = "petIsotopeModule";
    MetadataModules["PET_SERIES"] = "petSeriesModule";
    MetadataModules["SOP_COMMON"] = "sopCommonModule";
    MetadataModules["ULTRASOUND_ENHANCED_REGION"] = "ultrasoundEnhancedRegionModule";
    MetadataModules["VOI_LUT"] = "voiLutModule";
    MetadataModules["FRAME_MODULE"] = "frameModule";
    MetadataModules["WADO_WEB_CLIENT"] = "wadoWebClient";
    MetadataModules["INSTANCE"] = "instance";
    MetadataModules["IMAGE_SOP_INSTANCE_REFERENCE"] = "ImageSopInstanceReference";
    MetadataModules["REFERENCED_SERIES_REFERENCE"] = "ReferencedSeriesReference";
    MetadataModules["PREDECESSOR_SEQUENCE"] = "PredecessorSequence";
    MetadataModules["STUDY_DATA"] = "StudyData";
    MetadataModules["SERIES_DATA"] = "SeriesData";
    MetadataModules["IMAGE_DATA"] = "ImageData";
    MetadataModules["RTSS_INSTANCE_DATA"] = "RtssInstanceData";
    MetadataModules["NEW_INSTANCE_DATA"] = "NewInstanceData";
    MetadataModules["RTSS_CONTOUR"] = "metaRTSSContour";
    MetadataModules["SEG_BIT"] = "metaSegBitmap";
    MetadataModules["SR_ANNOTATION"] = "metaSrAnnotation";
})(MetadataModules || (MetadataModules = {}));
export default MetadataModules;
